/**
 * Labstep
 *
 * @module screens/ResourceTemplate/Show/Center
 * @desc ResourceTemplate Show Center
 */

import { EntityPrimaryInfo } from 'labstep-web/components/Entity/PrimaryInfo';
import {
  Action,
  ResourceTemplateActionMenu,
} from 'labstep-web/components/ResourceTemplate/Action/Menu';
import { ResourceTemplateLayoutLinks } from 'labstep-web/components/ResourceTemplate/LayoutLinks';
import { ICONS } from 'labstep-web/constants/icons';
import { InformationCard } from 'labstep-web/core/Card/Information';
import type React from 'react';
import type { ICenterProps } from './types';

export const Center: React.FC<ICenterProps> = ({
  resourceTemplate,
}) => (
  <InformationCard
    actionMenu={
      <ResourceTemplateActionMenu
        resourceTemplate={resourceTemplate}
        actions={[
          Action.duplicate,
          Action.share,
          Action.delete,
          Action.transfer_ownership,
          Action.export,
        ]}
      />
    }
    primaryInfo={
      <EntityPrimaryInfo
        entity={resourceTemplate}
        icon={ICONS.resource_template.primary}
      />
    }
    bottom={
      <ResourceTemplateLayoutLinks
        resourceTemplate={resourceTemplate}
      />
    }
  />
);
